import { render, staticRenderFns } from "./NewStorageRow.vue?vue&type=template&id=e5261520"
import script from "./NewStorageRow.vue?vue&type=script&lang=js"
export * from "./NewStorageRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports